import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class RightSidebarService {
  // Subject para notificar mudanças de tema
  themeChange = new Subject<void>();

  private _isOpenSidebar: boolean;
  private statusSubject = new Subject<boolean>();

  private statusService = new BehaviorSubject<boolean>(false);
  currentStatus = this.statusService.asObservable();
  constructor() {
    this._isOpenSidebar = false;
  }
  changeMsg(msg: boolean) {
    this.statusService.next(msg);
  }
}
